import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { applicationStore, LoginStatus } from "@website/store/store";
import { useWebengage } from "@website/tracking/tracking.webengage.hook";
import { getChannel } from "@website/utils/channel/get-channel";
import { setChannel } from "@website/utils/channel/set-channel";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { convertToken, useAuthSessionRefresh, useLoginStatus } from "./utils";

setChannel();

export const useAuthPages = () => {
  const router = useRouter();
  const { loginStatus } = useLoginStatus();
  const currentChannel = getChannel();
  const isPwa = toString(router?.query?.ispwa);
  const appVersion = toString(router?.query?.app_version);
  const queryToken = toString(router?.query?.token);
  useConvertTokenPages();
  useAuthSessionRefresh({
    routeChangeKey: router.asPath,
    queryToken
  });
  useEffect(() => {
    if (isPwa) {
      applicationStore.applicationData.isPwa.set(isPwa === "true");
    }
    if (appVersion) {
      applicationStore.applicationData.appVersion.set(appVersion);
    }
  }, [isPwa, appVersion]);

  useEffect(() => {
    const channel = getChannel();
    const channelHasRedirectState = channel === "b2b" || channel === "telesale";
    if (
      channelHasRedirectState &&
      loginStatus === LoginStatus.LoggedOut &&
      router.pathname !== "/b2b-login"
    ) {
      window.location.href = `/b2b-login`;
    }
  }, [loginStatus, router.pathname, currentChannel]);
};

export const useConvertTokenPages = () => {
  const router = useRouter();
  const { login } = useWebengage();

  const queryToken = toString(router.query?.token);
  useFetcherV2({
    queryKey: ["auth-cookie", "convert-token", getChannel(), queryToken],
    enabled: true,
    queryFn: async () => {
      await convertToken(queryToken, login);
    }
  });
};
